import gql from 'graphql-tag';

/**
 * Data of the block project-technical-review-dc ("Techn. Prüfung - DC"): the four DC fields of
 * `technicalReview`. Read through `Project.blocks.technicalReviewDc`, which checks the block's read
 * permission.
 */
export const PROJECT_TECHNICAL_REVIEW_DC_FIELDS = gql`
  fragment projectTechnicalReviewDcFields on ProjectTechnicalReviewDcBlock {
    id
    number
    technicalReview {
      dcInspectedState
      dcNotes
      expectedDcTimeExpenditureInSeconds
      dcInstallationTeamNotes
    }
  }
`;
